module.exports = __webpack_public_path__ + "img/gmail-delete-existing.6f227b53.png";